import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

const Page404 = () => import('@/views/pages/Page404');

Vue.use(Router);

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      meta: {
        authorized: false
      },
      name: 'Auth',
      component: {
        render(c) {
          return c('router-view');
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          meta: {
            authorized: false
          },
          component: () => {
            return import(
              /* webpackChunkName: "Auth.Login" */ '@/views/pages/Login.vue'
            );
          }
        },
        {
          path: '/forgot-password',
          name: 'ForgotPassword',
          meta: {
            authorized: false
          },
          component: () => {
            return import(
              /* webpackChunkName: "Auth.ForgotPassword" */ '@/views/pages/ForgotPassword.vue'
            );
          }
        },
        {
          path: '/resetPassword/:userid/:token',
          name: 'ResetPassword',
          meta: {
            authorized: false
          },
          component: () => {
            return import(
              /* webpackChunkName: "Auth.ResetPassword" */ '@/views/pages/ResetPassword.vue'
            );
          }
        }
      ]
    },

    {
      path: '/',
      component: DefaultContainer,
      children: [
        /*  Communications */
        {
          path: '/communications/:openChannelId?',
          name: 'Communications.Index',
          props: true,
          meta: {
            label: 'Communications Center',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Communications.Index" */ '../views/pages/communications/Index.vue'
            );
          }
        },
        {
          path: '/communications/view/:openChannelId?',
          name: 'Communications.Index2',
          props: true,
          meta: {
            label: 'Communications Center',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Communications.Index" */ '../views/pages/communications/Index.vue'
            );
          }
        },

        /* Invoices Gen via PTC */
        {
          path: '/billing/customerInvoices/view/:id',
          name: 'Billing.CustomerInvoices.View',
          props: true,
          meta: {
            label: 'View Invoice Details',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerInvoices.View" */ '../views/pages/billing/customerInvoices/View.vue'
            );
          }
        },
        /* Invoices Gen via PTC */
        {
          path: '/billing/customerInvoices/generate',
          name: 'Billing.CustomerInvoices.GenerateNewInvoice',
          meta: {
            label: 'Generate Invoice',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerInvoices.GenerateNewInvoice" */ '../views/pages/billing/customerInvoices/GenerateNewInvoice.vue'
            );
          }
        },
        /* Invoices Upload Existing */
        {
          path: '/billing/customerInvoices/uploadExisting',
          name: 'Billing.CustomerInvoices.UploadExisting',
          meta: {
            label: 'Upload Existing Invoice',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerInvoices.UploadExisting" */ '../views/pages/billing/customerInvoices/UploadExisting.vue'
            );
          }
        },
        /* SKU Maintenance */
        {
          path: '/skuMaintenance',
          name: 'SkuMaintenance.Index',
          meta: {
            label: 'SKU Maintenance',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "SkuMaintenance.Index" */ '../views/pages/admin/skuMaintenance/Index.vue'
            );
          }
        },

        /* Tickets */
        {
          path: '/support/tickets/all',
          name: 'Support.Tickets.All',
          meta: {
            label: 'All Tickets',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.Tickets.All" */ '@/views/pages/integrations/support/tickets/Index'
            );
          }
        },
        {
          path: '/support/tickets/create',
          name: 'Support.Tickets.Create',
          meta: {
            label: 'Create a new Ticket',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.Tickets.Form" */ '@/views/pages/integrations/support/tickets/Form'
            );
          }
        },
        {
          path: '/support/tickets/view/:id',
          name: 'Support.Tickets.View',
          props: true,
          meta: {
            label: 'View Ticket',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.Tickets.Form" */ '../views/pages/integrations/support/tickets/Form.vue'
            );
          }
        },
        /* integrations pages */
        {
          path: 'integrations',
          meta: {
            label: 'Integrations'
          },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            {
              path: 'irms',
              meta: {
                label: 'IRMS'
              },
              component: {
                render(c) {
                  return c('router-view');
                }
              },
              children: [
                /* IRMS POs */
                {
                  path: 'purchaseOrders',
                  name: 'IRMS.POs',
                  meta: {
                    label: 'IRMS Purchase Orders',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "IRMS.POs" */ '@/views/pages/reports/IRMS/POs.vue'
                    );
                  }
                },
                /* IRMS COs */
                {
                  path: 'customerOrders',
                  name: 'IRMS.COs',
                  meta: {
                    label: 'IRMS Customer Orders',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "IRMS.COs" */ '@/views/pages/reports/IRMS/COs.vue'
                    );
                  }
                }
              ]
            },

            {
              path: 'api-access',
              name: 'Integrations.APIAccess.Index',
              props: true,
              meta: {
                label: 'List API Access',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Integrations.ApiAccess.Index" */ '@/views/pages/integrations/apiAccess/Index'
                );
              }
            },
            {
              path: 'api-access/create',
              name: 'Integrations.ApiAccess.Create',
              props: true,
              meta: {
                label: 'Create API Access',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Integrations.ApiAccess.Form" */ '@/views/pages/integrations/apiAccess/Form'
                );
              }
            },
            {
              path: 'api-access/edit/:id',
              name: 'Integrations.ApiAccess.Edit',
              props: true,
              meta: {
                label: 'Edit API Access',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Integrations.ApiAccess.Form" */ '@/views/pages/integrations/apiAccess/Form'
                );
              }
            },

            {
              path: 'tpl',
              meta: {
                label: 'Extensiv'
              },
              component: {
                render(c) {
                  return c('router-view');
                }
              },
              children: [
                /* Facilities */
                {
                  path: 'facilities',
                  name: 'TPL.Facilities.Index',
                  meta: {
                    label: 'Facilities',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Facilities.Index" */ '@/views/pages/integrations/tpl/facilities/Index'
                    );
                  }
                },
                {
                  path: 'facilities/edit/:id',
                  name: 'TPL.Facilities.Edit',
                  props: true,
                  meta: {
                    label: 'Edit Facility',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Facilities.Form" */ '@/views/pages/integrations/tpl/facilities/Form'
                    );
                  }
                },

                /* Customers */
                {
                  path: 'customers',
                  name: 'TPL.Customers.Index',
                  meta: {
                    label: 'Customers',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Customers.Index" */ '@/views/pages/integrations/tpl/customers/Index'
                    );
                  }
                },
                {
                  path: 'customers/edit/:id',
                  name: 'TPL.Customers.Edit',
                  props: true,
                  meta: {
                    label: 'Edit Customer',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Customers.Form" */ '@/views/pages/integrations/tpl/customers/Form'
                    );
                  }
                },

                /* Carriers */
                {
                  path: 'adjustments',
                  name: 'TPL.Adjustments.Index',
                  meta: {
                    label: 'Adjustments',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Adjustments.Index" */ '@/views/pages/integrations/tpl/adjustments/Index'
                    );
                  }
                },

                /* Carriers */
                {
                  path: 'carriers',
                  name: 'TPL.Carriers.Index',
                  meta: {
                    label: 'Carriers',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Carriers.Index" */ '@/views/pages/integrations/tpl/carriers/Index'
                    );
                  }
                },
                {
                  path: 'carriers/edit/:id',
                  name: 'TPL.Carriers.Edit',
                  props: true,
                  meta: {
                    label: 'Edit Carrier',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Carriers.Form" */ '@/views/pages/integrations/tpl/carriers/Form'
                    );
                  }
                },

                /* UOMs */
                {
                  path: 'uom',
                  name: 'TPL.UOM.Index',
                  meta: {
                    label: 'UOM',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.UOM.Index" */ '@/views/pages/integrations/tpl/uom/Index'
                    );
                  }
                },
                {
                  path: 'uom/edit/:id',
                  name: 'TPL.UOM.Edit',
                  props: true,
                  meta: {
                    label: 'Edit UOM',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.UOM.Form" */ '@/views/pages/integrations/tpl/uom/Form'
                    );
                  }
                },

                /* Billing Codes */
                {
                  path: 'billing-codes',
                  name: 'TPL.BillingCodes.Index',
                  meta: {
                    label: 'Billing Codes',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.BillingCodes.Index" */ '@/views/pages/integrations/tpl/billingCodes/Index'
                    );
                  }
                },
                {
                  path: 'billing-codes/edit/:id',
                  name: 'TPL.BillingCodes.Edit',
                  props: true,
                  meta: {
                    label: 'Edit Billing Code',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.BillingCodes.Form" */ '@/views/pages/integrations/tpl/billingCodes/Form'
                    );
                  }
                },

                /* Shipment Services */
                {
                  path: 'shipment-services',
                  name: 'TPL.ShipmentServices.Index',
                  meta: {
                    label: 'Shipment Services',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.ShipmentServices.Index" */ '@/views/pages/integrations/tpl/shipmentServices/Index'
                    );
                  }
                },
                {
                  path: 'shipment-services/edit/:id',
                  name: 'TPL.ShipmentServices.Edit',
                  props: true,
                  meta: {
                    label: 'Edit Shipment Service',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.ShipmentServices.Form" */ '@/views/pages/integrations/tpl/shipmentServices/Form'
                    );
                  }
                },

                /* Receivers */
                {
                  path: 'receivers',
                  name: 'TPL.Receivers.Index',
                  meta: {
                    label: 'Advanced Shipping Notices',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Receivers.Index" */ '@/views/pages/integrations/tpl/receivers/Index'
                    );
                  }
                },
                {
                  path: 'receivers/create',
                  name: 'TPL.Receivers.Create',
                  props: true,
                  meta: {
                    label: 'TEST Advanced Shipping Notice',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Receivers.Form" */ '@/views/pages/integrations/tpl/receivers/Form'
                    );
                  }
                },
                {
                  path: 'receivers/edit/:id',
                  name: 'TPL.Receivers.Edit',
                  props: true,
                  meta: {
                    label: 'Edit Advanced Shipping Notice',
                    authorized: true
                  },
                  component: () => {
                    return import(
                      /* webpackChunkName: "TPL.Receivers.Form" */ '@/views/pages/integrations/tpl/receivers/Form'
                    );
                  }
                }
              ]
            },
          ]
        },

        /* storefront pages */
        {
          path: 'storefronts',
          meta: {
            label: 'Storefronts'
          },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            /* --- Storefronts --- */
            {
              path: 'manage',
              name: 'Storefronts.Manage.Index',
              props: true,
              meta: {
                label: 'Manage Storefronts',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.Manage.Index" */ '@/views/pages/storefronts/manage/Index'
                );
              }
            },
            {
              path: 'manage/create',
              name: 'Storefronts.Manage.Create',
              props: true,
              meta: {
                label: 'Create Storefront',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.Manage.Form" */ '@/views/pages/storefronts/manage/Form'
                );
              }
            },
            {
              path: 'manage/edit/:id',
              name: 'Storefronts.Manage.Edit',
              props: true,
              meta: {
                label: 'Edit Storefront',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.Manage.Form" */ '@/views/pages/storefronts/manage/Form'
                );
              }
            },
            /* Order returns */
            {
              path: 'order-returns',
              name: 'Storefronts.OrderReturns.Index',
              props: true,
              meta: {
                label: 'Create Return Label',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Common.CreateReturnLabel" */ '@/views/pages/storefronts/returns/Index'
                );
              }
            },
            {
              path: 'order-returns/createLabel/:orderId?',
              name: 'Storefronts.OrderReturns.CreateReturnLabel',
              props: true,
              meta: {
                label: 'Create Return Label',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Common.CreateReturnLabel" */ '@/views/pages/storefronts/returns/CreateReturnLabel'
                );
              }
            },
            {
              path: 'order-returns/confirm/:orderId?',
              name: 'Storefronts.OrderReturns.ConfirmReturn',
              props: true,
              meta: {
                label: 'Confirm Return',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Common.ConfirmReturn" */ '@/views/pages/storefronts/returns/ConfirmReturn'
                );
              }
            },
            {
              path: 'order-returns/view/:orderReturnId?',
              name: 'Storefronts.OrderReturns.Edit',
              props: true,
              meta: {
                label: 'Order Return',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.OrderReturns.Edit" */ '@/views/pages/storefronts/returns/Form'
                );
              }
            },
            /* ShipCode Mappings */
            {
              path: 'shipcode-mappings',
              name: 'Storefronts.ShipCodeMappings.Index',
              meta: {
                label: 'ShipCode Mappings',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.ShipCodeMappings.Index" */ '@/views/pages/storefronts/shipCodeMappings/Index'
                );
              }
            },
            {
              path: 'shipcode-mappings/create',
              name: 'Storefronts.ShipCodeMappings.Create',
              meta: {
                label: 'Create ShipCode Mapping',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.ShipCodeMappings.Form" */ '@/views/pages/storefronts/shipCodeMappings/Form'
                );
              }
            },
            {
              path: 'shipcode-mappings/edit/:id',
              name: 'Storefronts.ShipCodeMappings.Edit',
              props: true,
              meta: {
                label: 'Edit ShipCode Mapping',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.ShipCodeMappings.Form" */ '@/views/pages/storefronts/shipCodeMappings/Form'
                );
              }
            },
            /* StorefrontRateShops */
            {
              path: 'storefront-rate-shops',
              name: 'Storefronts.StorefrontRateShops.Index',
              meta: {
                label: 'Storefront Rate Shop',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.StorefrontRateShops.Index" */ '@/views/pages/storefronts/storefrontRateShops/Index'
                );
              }
            },
            {
              path: 'storefront-rate-shops/create',
              name: 'Storefronts.StorefrontRateShops.Create',
              meta: {
                label: 'Create Storefront Rate Shop',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.StorefrontRateShops.Form" */ '@/views/pages/storefronts/storefrontRateShops/Form'
                );
              }
            },
            {
              path: 'storefront-rate-shops/edit/:id',
              name: 'Storefronts.StorefrontRateShops.Edit',
              props: true,
              meta: {
                label: 'Edit Storefront Rate Shop',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.StorefrontRateShops.Form" */ '@/views/pages/storefronts/storefrontRateShops/Form'
                );
              }
            },
            /* ---- Storefront Product Groups ---- */
            {
              path: 'product-groups',
              name: 'Storefronts.ProductGroups.Index',
              meta: {
                label: 'Product Groups',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.ProductGroups.Index" */ '@/views/pages/storefronts/productGroups/Index'
                );
              }
            },
            {
              path: 'product-groups/create',
              name: 'Storefronts.ProductGroups.Create',
              meta: {
                label: 'Create Product Group',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.ProductGroups.Form" */ '@/views/pages/storefronts/productGroups/Form'
                );
              }
            },
            {
              path: 'product-groups/edit/:id',
              name: 'Storefronts.ProductGroups.Edit',
              props: true,
              meta: {
                label: 'Edit Product Group',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.ProductGroups.Form" */ '@/views/pages/storefronts/productGroups/Form'
                );
              }
            },
            /* Shipments List */
            {
              path: 'shipments',
              name: 'Storefronts.Shipments.Index',
              props: true,
              meta: {
                label: 'Shipments',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.Shipments.Index" */ '@/views/pages/storefronts/shipments/Index'
                );
              }
            },
            /* Shipment Labels List */
            {
              path: 'labels',
              name: 'Storefronts.Labels.Index',
              props: true,
              meta: {
                label: 'Shipment Labels',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.Labels.Index" */ '@/views/pages/storefronts/labels/Index'
                );
              }
            },
            /* Order Groups */
            {
              path: 'order-groups',
              name: 'Storefronts.OrderGroups.Index',
              props: true,
              meta: {
                label: 'Order Groups',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.OrderGroups.Index" */ '@/views/pages/storefronts/orderGroups/Index'
                );
              }
            },
            {
              path: 'order-groups/create',
              name: 'Storefronts.OrderGroups.Create',
              props: true,
              meta: {
                label: 'New Order Group',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.OrderGroups.Form" */ '@/views/pages/storefronts/orderGroups/Form'
                );
              }
            },
            {
              path: 'order-groups/edit/:id',
              name: 'Storefronts.OrderGroups.Edit',
              props: true,
              meta: {
                label: 'Edit Order Group',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.OrderGroups.Form" */ '@/views/pages/storefronts/orderGroups/Form'
                );
              }
            },
            /* Order Tags */
            {
              path: 'order-tags',
              name: 'Storefronts.OrderTags.Index',
              meta: {
                label: 'Order Tags',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.OrderTags.Index" */ '@/views/pages/storefronts/orderTags/Index'
                );
              }
            },
            {
              path: 'order-tags/edit/:id',
              name: 'Storefronts.OrderTags.Edit',
              props: true,
              meta: {
                label: 'Edit Order Tag',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.OrderTags.Form" */ '@/views/pages/storefronts/orderTags/Form'
                );
              }
            },
            /* Storefront Products */
            {
              path: 'products',
              name: 'Storefronts.StorefrontProducts.Index',
              meta: {
                label: 'Storefront Products',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.StorefrontProducts.Index" */ '@/views/pages/storefronts/storefrontProducts/Index'
                );
              }
            },
            {
              path: 'products/create',
              name: 'Storefronts.StorefrontProducts.Create',
              props: true,
              meta: {
                label: 'Create Storefront Product',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.StorefrontProducts.Form" */ '@/views/pages/storefronts/storefrontProducts/Form'
                );
              }
            },
            {
              path: 'products/edit/:id',
              name: 'Storefronts.StorefrontProducts.Edit',
              props: true,
              meta: {
                label: 'Edit Storefront Product',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Storefronts.StorefrontProducts.Form" */ '@/views/pages/storefronts/storefrontProducts/Form'
                );
              }
            }
          ]
        },
        /* --- storefront pages --- */
        {
          path: 'other',
          meta: {
            label: 'Other'
          },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            /* Automation */
            {
              path: 'automation',
              name: 'Other.Automation.Index',
              meta: {
                label: 'Automation',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Other.Automation.Index" */ '@/views/pages/other/automation/Index'
                );
              }
            },
            {
              path: 'automation/create',
              name: 'Other.Automation.Create',
              meta: {
                label: 'Create Automation',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Other.Automation.Form" */ '@/views/pages/other/automation/Form'
                );
              }
            },
            {
              path: 'automation/edit/:id',
              name: 'Other.Automation.Edit',
              props: true,
              meta: {
                label: 'Edit Automation',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Other.Automation.Form" */ '@/views/pages/other/automation/Form'
                );
              }
            },

            /* Automation Logs */
            {
              path: 'automation/log',
              name: 'Other.AutomationsContent.Index',
              meta: {
                label: 'Automations Log',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Other.AutomationsContent.Index" */ '@/views/pages/other/automationsContent/Index'
                );
              }
            },

            /* Content Templates */
            {
              path: 'automation/content-templates',
              name: 'Other.ContentTemplates.Index',
              meta: {
                label: 'Content Templates',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Other.ContentTemplates.Index" */ '@/views/pages/other/contentTemplates/Index'
                );
              }
            },
            {
              path: 'automation/content-templates/create',
              name: 'Other.ContentTemplates.Create',
              meta: {
                label: 'Create Content Template',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Other.ContentTemplates.Form" */ '@/views/pages/other/contentTemplates/Form'
                );
              }
            },
            {
              path: 'automation/content-templates/edit/:id',
              name: 'Other.ContentTemplates.Edit',
              props: true,
              meta: {
                label: 'Edit Content Template',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Other.ContentTemplates.Form" */ '@/views/pages/other/contentTemplates/Form'
                );
              }
            }
          ]
        },
        /* ./ other pages */

        /* --- warehouse pages --- */
        {
          path: 'warehouses',
          meta: {
            label: 'Warehouses'
          },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children:[
            /* Warehouses */
            {
              path: 'manage',
              name: 'Warehouses.Index',
              meta: {
                label: 'Warehouses',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.Index" */ '../views/pages/warehouses/manage/Index.vue'
                );
              }
            },
            {
              path: 'create',
              name: 'Warehouses.Create',
              meta: {
                label: 'Create Warehouse',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.Form" */ '../views/pages/warehouses/manage/Form.vue'
                );
              }
            },
            {
              path: 'edit/:id',
              name: 'Warehouses.Edit',
              props: true,
              meta: {
                label: 'Edit Warehouse',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.Form" */ '../views/pages/warehouses/manage/Form.vue'
                );
              }
            },
            /* ---- Storefront Product Groups ---- */
            {
              path: 'item-groups',
              name: 'Warehouses.ProductGroups.Index',
              meta: {
                label: 'Product Groups',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.ProductGroups.Index" */ '@/views/pages/warehouses/productGroups/Index'
                );
              }
            },
            {
              path: 'item-groups/create',
              name: 'Warehouses.ProductGroups.Create',
              meta: {
                label: 'Create Product Group',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.ItemGroups.Form" */ '@/views/pages/warehouses/productGroups/Form'
                );
              }
            },
            {
              path: 'item-groups/edit/:id',
              name: 'Warehouses.ProductGroups.Edit',
              props: true,
              meta: {
                label: 'Edit Product Group',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.ProductGroups.Form" */ '@/views/pages/warehouses/productGroups/Form'
                );
              }
            },
            {
              path: 'items',
              name: 'Warehouses.Items',
              meta: {
                label: 'Inventory',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.Items" */ '../views/pages/warehouses/warehouseItems/Items.vue'
                );
              }
            },
            {
              path: 'items/:id',
              name: 'Warehouses.Items.Form',
              props: true,
              meta: {
                label: 'Warehouse Item',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.Items.Form" */ '../views/pages/warehouses/warehouseItems/WarehouseItemForm.vue'
                );
              }
            },
            {
              path: 'items-with-some-offset',
              name: 'Warehouses.ItemsWithOffset',
              meta: {
                label: 'Warehouse Items - Inventory Tracking Off',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.ItemsListingVirtualWithOffset" */ '../views/pages/warehouses/warehouseItems/ItemsListingVirtualWithOffset.vue'
                );
              }
            },
          ]
        },
        /* --- warehouse pages --- */
        {
          path: 'inventory',
          meta: {
            label: 'Inventory'
          },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            /* Inventory DIU */
            {
              path: 'adjustments',
              name: 'Inventory.DIU.Index',
              meta: {
                label: 'Adjustments List',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Inventory.DIU.Index" */ '@/views/pages/integrations/directInventoryUpdates/Index'
                );
              }
            },
            {
              path: 'adjustments/create',
              name: 'Inventory.DIU.Create',
              meta: {
                label: 'Create a new DIU',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Inventory.DIU.Form" */ '@/views/pages/integrations/directInventoryUpdates/Form'
                );
              }
            },
            {
              path: 'adjustments/view/:id',
              name: 'Inventory.DIU.View',
              props: true,
              meta: {
                label: 'View DIU',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Inventory.DIU.Form" */ '../views/pages/integrations/directInventoryUpdates/Form.vue'
                );
              }
            },

            /* Packing Lists */
            {
              path: 'packing-lists',
              name: 'PackingList.Index',
              meta: {
                label: 'Packing Lists',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "PackingList.Index" */ '@/views/pages/transfers/packingList/Index'
                );
              }
            },
            {
              path: 'packing-lists/create',
              name: 'PackingList.Create',
              meta: {
                label: 'Create a new Packing List',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "PackingList.Form" */ '@/views/pages/transfers/packingList/Form'
                );
              }
            },
            {
              path: 'packing-lists/edit/:id',
              name: 'PackingList.Edit',
              props: true,
              meta: {
                label: 'Edit Packing List',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "PackingList.Form" */ '../views/pages/transfers/packingList/Form.vue'
                );
              }
            },
            /* ----Packing Lists */

            {
              path: 'shipments/:id/create',
              name: 'Warehouses.CreateShipment',
              props: true,
              meta: {
                label: 'Create Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.CreateShipment" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },

            {
              path: 'purchaseOrders/:purchaseOrderId/createBatch',
              name: 'Warehouses.PurchaseOrders.CreateWorkOrderBatch',
              props: true,
              meta: {
                label: 'Schedule a Batch',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.CreateWorkOrderBatch" */ '@/views/pages/transfers/purchaseOrders/CreateWorkOrderBatch.vue'
                );
              }
            },
            {
              path: 'purchaseOrders/:purchaseOrderId/receive',
              name: 'Warehouses.PurchaseOrders.ReceiveShipment',
              props: true,
              meta: {
                label: 'Ship Items',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.ReceiveShipment" */ '@/views/pages/transfers/purchaseOrders/ReceiveShipment.vue'
                );
              }
            },
            {
              path: 'purchaseOrders/:purchaseOrderId/create',
              name: 'Warehouses.PurchaseOrders.CreateShipment',
              props: true,
              meta: {
                label: 'Ship Items',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.CreateShipment" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },
            {
              path: 'advancedShipNotices/:shipmentId/confirm',
              name: 'Warehouses.AdvancedShipNotice.ConfirmShipment',
              props: true,
              meta: {
                label: 'Confirm Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.AdvancedShipNotice.ConfirmShipment" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },
            {
              path: 'warehouseTransfers/:shipmentId/confirm',
              name: 'Warehouses.WarehouseTransfers.ConfirmShipment',
              props: true,
              meta: {
                label: 'Ship Items',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.ConfirmShipment" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },
            {
              path: 'warehouseTransfers/:shipmentId/allocate',
              name: 'Warehouses.WarehouseTransfers.AllocateShipment',
              props: true,
              meta: {
                label: 'Allocate Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.WarehouseTransfers.Allocate" */ '@/views/pages/transfers/purchaseOrders/AllocateShipment.vue'
                );
              }
            },
            {
              path: 'warehouseTransfers/:shipmentId/create',
              name: 'Warehouses.WarehouseTransfers.CreateShipment',
              props: { default: true, isWT: true },
              meta: {
                label: 'Ship Items',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.CreateShipment" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },
            {
              path: 'advancedShipNotice/recreate/:recreateFromShipmentId',
              name: 'Warehouses.AdvancedShipNotice.ReCreate',
              props: true,
              meta: {
                label: 'Recreate Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.AdvancedShipNotice.ReCreate" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },
            {
              path: 'advancedShipNotice/create',
              name: 'Warehouses.AdvancedShipNotice.Create',
              props: true,
              meta: {
                label: 'Advanced Ship Notices',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.AdvancedShipNotice.Create" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },

            {
              path: 'advancedShipNotice',
              name: 'Warehouses.AdvancedShipNotice.Index',
              props: true,
              meta: {
                label: 'Advanced Ship Notices',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.AdvancedShipNotice.Index" */ '@/views/pages/transfers/purchaseOrders/AdvancedShipNotices.vue'
                );
              }
            },
            {
              path: 'warehouseTransfers',
              name: 'Warehouses.WarehouseTransfers.Index',
              props: true,
              meta: {
                label: 'Warehouse Transfers',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.WarehouseTransfers.Index" */ '@/views/pages/transfers/purchaseOrders/WarehouseTransfers.vue'
                );
              }
            },
            {
              path: 'warehouseTransfers/:shipmentId/receive',
              name: 'Warehouses.WarehouseTransfers.ReceiveShipment',
              props: { default: true, isWT: true },
              meta: {
                label: 'Ship Items',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.ReceiveShipment" */ '@/views/pages/transfers/purchaseOrders/ReceiveShipment.vue'
                );
              }
            },
            {
              path: 'purchaseOrders',
              name: 'Warehouses.PurchaseOrders.Index',
              props: true,
              meta: {
                label: 'Purchase Orders',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.Index" */ '@/views/pages/transfers/purchaseOrders/Index.vue'
                );
              }
            },

            {
              path: 'advancedShipNotice/view/:id',
              name: 'Warehouses.AdvancedShipNotice.View',
              props: { default: true, isWT: false },
              meta: {
                label: 'View Advanced Ship Notice',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.AdvancedShipNotice.View" */ '@/views/pages/transfers/purchaseOrders/ViewShipment.vue'
                );
              }
            },
            {
              path: 'warehouseTransfers/view/:id',
              name: 'Warehouses.WarehouseTransfers.View',
              props: { default: true, isWT: true },
              meta: {
                label: 'View Warehouse Transfer',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.WarehouseTransfers.View" */ '@/views/pages/transfers/purchaseOrders/ViewShipment.vue'
                );
              }
            },
            {
              path: 'warehouseTransfers/create',
              name: 'Warehouses.WarehouseTransfers.Create',
              props: { default: true, isWT: true },
              meta: {
                label: 'Create new Warehouse Transfer',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.WarehouseTransfers.CreateShipment" */ '@/views/pages/transfers/purchaseOrders/CreateShipment.vue'
                );
              }
            },
            {
              path: 'purchaseOrders/create',
              name: 'Warehouses.PurchaseOrders.Create',
              props: { default: true, isWT: false },
              meta: {
                label: 'Create new Purchase Order',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.Form" */ '@/views/pages/transfers/purchaseOrders/Form.vue'
                );
              }
            },
            {
              path: 'purchaseOrders/edit/:id',
              name: 'Warehouses.PurchaseOrders.Edit',
              props: true,
              meta: {
                label: 'Edit Order',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.Form" */ '@/views/pages/transfers/purchaseOrders/Form.vue'
                );
              }
            },
            {
              path: 'purchaseOrders/view/:id',
              name: 'Warehouses.PurchaseOrders.View',
              props: true,
              meta: {
                label: 'View Purchase Order',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.PurchaseOrders.View" */ '@/views/pages/transfers/purchaseOrders/View.vue'
                );
              }
            },
            {
              path: 'itemsByLocation',
              name: 'Warehouses.Items.Locations',
              meta: {
                label: 'Warehouse Item Locations',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.Items.Locations" */ '../views/pages/warehouses/warehouseProductLocations/Index.vue'
                );
              }
            },
            /* ---- Bulk Shipments ---- */
            {
              path: 'bulkShipments',
              name: 'Warehouses.BulkShipments.Index',
              meta: {
                label: 'Bulk Shipments',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.BulkShipments.Index" */ '@/views/pages/transfers/bulkShipments/Index'
                );
              }
            },
            {
              path: 'bulkShipments/:id',
              name: 'Warehouses.BulkShipments.View',
              props: true,
              meta: {
                label: 'View Bulk Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.BulkShipments.View" */ '@/views/pages/transfers/bulkShipments/Form'
                );
              }
            },
            {
              path: 'bulkShipments/allocate/:bulkShipmentId',
              name: 'Warehouses.BulkShipments.AllocateShipment',
              props: true,
              meta: {
                label: 'Allocate Bulk Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.BulkShipments.AllocateShipment" */ '@/views/pages/transfers/bulkShipments/AllocateShipment'
                );
              }
            },

            {
              path: 'bulkShipments/create',
              name: 'Warehouses.BulkShipments.Create',
              meta: {
                label: 'Create Bulk Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.BulkShipments.Form" */ '@/views/pages/transfers/bulkShipments/Form'
                );
              }
            },
            {
              path: 'manual-shipments',
              name: 'Warehouses.ManualShipments.Index',
              meta: {
                label: 'Small parcel Shipments',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.ManualShipments.Index" */ '@/views/pages/transfers/manualShipments/Index'
                );
              }
            },
            {
              path: 'manual-shipments/edit/:id',
              name: 'Warehouses.ManualShipments.Edit',
              props: true,
              meta: {
                label: 'Edit Manual Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.ManualShipments.Form" */ '@/views/pages/transfers/manualShipments/Form'
                );
              }
            },
            {
              path: 'manual-shipments/create',
              name: 'Warehouses.ManualShipments.Create',
              meta: {
                label: 'Create Manual Shipment',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Warehouses.ManualShipments.Form" */ '@/views/pages/transfers/manualShipments/Form'
                );
              }
            },
            {
              path: 'import-sheet-mapping-methods',
              name: 'Transfers.ImportSheetMappingMethods.Index',
              meta: {
                label: 'Import Sheet Mapping Methods',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Transfers.ImportSheetMappingMethods.Index" */ '@/views/pages/transfers/importSheetMappingMethods/Index'
                );
              }
            },
            {
              path: 'import-sheet-mapping-methods/edit/:id',
              name: 'Transfers.ImportSheetMappingMethods.Edit',
              props: true,
              meta: {
                label: 'Edit Import Sheet Mapping Method',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Transfers.ImportSheetMappingMethods.Form" */ '@/views/pages/transfers/importSheetMappingMethods/Form'
                );
              }
            },
            {
              path: 'import-sheet-mapping-methods/create',
              name: 'Transfers.ImportSheetMappingMethods.Create',
              meta: {
                label: 'Create Import Sheet Mapping Method',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Transfers.ImportSheetMappingMethods.Form" */ '@/views/pages/transfers/importSheetMappingMethods/Form'
                );
              }
            },
          ]
        },
        /* all user pages */
        {
          path: '/profile/edit',
          name: 'Common.UserProfiles.EditMyProfile',
          props: true,
          meta: {
            label: 'Edit My Profile',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Common.UserProfiles.EditMyProfile" */ '@/views/pages/userProfiles/EditMyProfile'
            );
          }
        },
        {
          path: '/profile/:id',
          name: 'Common.UserProfiles.View',
          props: true,
          meta: {
            label: 'Profile',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Common.UserProfiles.View" */ '@/views/pages/userProfiles/View'
            );
          }
        },
        {
          path: '/profiles/list',
          name: 'Common.UserProfiles.Index',
          props: true,
          meta: {
            label: 'User Directory',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Common.UserProfiles.Index" */ '@/views/pages/userProfiles/Index'
            );
          }
        },
        {
          path: '/my-account',
          name: 'Common.MyAccount',
          meta: {
            label: 'My Account',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Common.MyAccount" */ '@/views/pages/common/MyAccount'
            );
          }
        },
        /* ./ all user pages */

        {
          path: '/',
          name: 'Dashboard',
          meta: {
            label: 'Dashboard',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Dashboard" */ '@/views/Dashboard'
            );
          }
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          meta: {
            label: 'Dashboard',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Dashboard" */ '@/views/Dashboard'
            );
          }
        },
        {
          path: '/redirectSupport',
          name: 'Support.TicketsRedirect',
          meta: {
            label: 'Tickets',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Support.TicketsRedirect" */ '@/views/pages/common/TicketsRedirect'
            );
          }
        },
        {
          path: '/manage/clients',
          name: 'Admin.Brands.Index',
          props: true,
          meta: {
            label: 'Clients',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Brands.Index" */ '@/views/pages/admin/clients/Index'
            );
          }
        },
        {
          path: '/manage/clients/items',
          name: 'Manage.BrandItems.Index',
          props: true,
          meta: {
            label: 'Client Items',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.BrandItems.Index" */ '@/views/pages/admin/brandItems/Index'
            );
          }
        },
        {
          path: '/manage/clients/items/edit/:id',
          name: 'Manage.BrandItems.Edit',
          props: true,
          meta: {
            label: 'Client Items',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Form" */ '@/views/pages/admin/brandItems/Form'
            );
          }
        },
        {
          path: '/manage/clients/items/create',
          name: 'Manage.BrandItems.Create',
          meta: {
            label: 'Client Items',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Form" */ '@/views/pages/admin/brandItems/Form'
            );
          }
        },

        /* Brand Fulfillment Boxes */
        {
          path: '/manage/brand-fulfillment-boxes',
          name: 'BrandFulfillmentBoxes.Index',
          meta: {
            label: 'Brand Fulfillment Boxes',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "BrandFulfillmentBoxes.Index" */ '@/views/pages/brandFulfillmentBoxes/Index'
            );
          }
        },
        {
          path: '/manage/brand-fulfillment-boxes/create',
          name: 'BrandFulfillmentBoxes.Create',
          meta: {
            label: 'Create Brand Fulfillment Box',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "BrandFulfillmentBoxes.Form" */ '@/views/pages/brandFulfillmentBoxes/Form'
            );
          }
        },
        {
          path: '/manage/brand-fulfillment-boxes/edit/:id',
          name: 'BrandFulfillmentBoxes.Edit',
          props: true,
          meta: {
            label: 'Edit Brand Fulfillment Box',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "BrandFulfillmentBoxes.Form" */ '@/views/pages/brandFulfillmentBoxes/Form'
            );
          }
        },

        /* Integration Carriers */
        {
          path: '/manage/integration-carriers',
          name: 'IntegrationCarriers.Index',
          meta: {
            label: 'Integration Carriers',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "IntegrationCarriers.Index" */ '@/views/pages/integrations/carrierConfig/Index'
            );
          }
        },
        {
          path: '/manage/integration-carriers/create',
          name: 'IntegrationCarriers.Create',
          meta: {
            label: 'Create Integration Carrier',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "IntegrationCarriers.Form" */ '@/views/pages/integrations/carrierConfig/Form'
            );
          }
        },
        {
          path: '/manage/integration-carriers/edit/:id',
          name: 'IntegrationCarriers.Edit',
          props: true,
          meta: {
            label: 'Edit Integration Carrier',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "IntegrationCarriers.Form" */ '@/views/pages/integrations/carrierConfig/Form'
            );
          }
        },

        /* Docs */
        {
          path: '/docs/knowledgebase/pages',
          name: 'Admin.Knowledgebase.Pages.Index',
          meta: {
            label: 'Knowledgebase Pages',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Index" */ '@/views/pages/knowledgebase/pages/Index'
            );
          }
        },
        {
          path: '/docs/knowledgebase/pages/edit/:id',
          name: 'Admin.Knowledgebase.Pages.Edit',
          props: true,
          meta: {
            label: 'Knowledgebase Pages',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Form" */ '@/views/pages/knowledgebase/pages/Form'
            );
          }
        },
        {
          path: '/docs/knowledgebase/pages/create',
          name: 'Admin.Knowledgebase.Pages.Create',
          meta: {
            label: 'Knowledgebase Pages',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Pages.Form" */ '@/views/pages/knowledgebase/pages/Form'
            );
          }
        },
        {
          path: '/docs/knowledgebase/groups',
          name: 'Admin.Knowledgebase.Groups.Index',
          meta: {
            label: 'Knowledgebase Groups',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Index" */ '@/views/pages/knowledgebase/groups/Index'
            );
          }
        },
        {
          path: '/docs/knowledgebase/groups/edit/:id',
          name: 'Admin.Knowledgebase.Groups.Edit',
          props: true,
          meta: {
            label: 'Knowledgebase Groups',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Form" */ '@/views/pages/knowledgebase/groups/Form'
            );
          }
        },
        {
          path: '/docs/knowledgebase/groups/create',
          name: 'Admin.Knowledgebase.Groups.Create',
          meta: {
            label: 'Knowledgebase Groups',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Form" */ '@/views/pages/knowledgebase/groups/Form'
            );
          }
        },
        {
          path: '/docs/changelog',
          name: 'Admin.Changelog.Index',
          meta: {
            label: 'Changelog',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Changelog.Index" */ '@/views/pages/knowledgebase/changelog/Index'
            );
          }
        },
        {
          path: '/docs/changelog/edit/:id',
          name: 'Admin.Changelog.Edit',
          props: true,
          meta: {
            label: 'Changelog - Update',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Changelog.Form" */ '@/views/pages/knowledgebase/changelog/Form'
            );
          }
        },
        {
          path: '/docs/changelog/create',
          name: 'Admin.Changelog.Create',
          meta: {
            label: 'Changelog Add Entry',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Knowledgebase.Groups.Form" */ '@/views/pages/knowledgebase/changelog/Form'
            );
          }
        },
        /* public docs pages */

        {
          path: '/changelog',
          name: 'ChangelogPublic',
          meta: {
            label: 'Changelog',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "ChangelogPublic" */ '@/views/pages/other/ChangelogPublic'
            );
          }
        },

        {
          path: '/docs',
          name: 'DocsHome',
          meta: {
            label: 'Docs',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "DocsHome" */ '@/views/pages/other/DocsHome'
            );
          }
        },
        {
          path: '/docs/article/:slug',
          name: 'ViewKnowledgeArticle',
          props: true,
          meta: {
            label: 'Docs Article',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "ViewKnowledgeArticle" */ '@/views/pages/other/ViewKnowledgeArticle'
            );
          }
        },
        {
          path: '/docs/group/:slug',
          name: 'ViewKnowledgeGroup',
          props: true,
          meta: {
            label: 'Article Group',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "ViewKnowledgeGroup" */ '@/views/pages/other/ViewKnowledgeGroup'
            );
          }
        },

        /* Customer Invoices */
        {
          path: '/manage/billing/customerInvoices',
          name: 'Billing.CustomerInvoices.Index',
          meta: {
            label: 'Client Invoices',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerInvoices.Index" */ '@/views/pages/billing/customerInvoices/Index'
            );
          }
        },
        {
          path: '/manage/billing/alertCenter',
          name: 'Billing.CustomerBillingLedger.AlertCenter',
          meta: {
            label: 'Billing Alert Center',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerBillingLedger.AlertCenter" */ '@/views/pages/billing/AlertCenter'
            );
          }
        },
        {
          path: '/manage/billing/customerBillingLedger',
          name: 'Billing.CustomerBillingLedger.EnterCustomCharge',
          meta: {
            label: 'Billing - Add Custom Charge',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerBillingLedger.CustomChargeForm" */ '@/views/pages/billing/CustomChargeForm'
            );
          }
        },
        {
          path: '/manage/billing/carrierBillingEntries',
          name: 'Billing.CarrierBillingEntries.Index',
          meta: {
            label: 'Billing - Carrier Billing Entries',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CarrierBillingEntries.Index" */ '@/views/pages/billing/carrierBillingEntries/Index'
            );
          }
        },
        {
          path: '/manage/billing/carrierInvoiceChargeConfigurations',
          name: 'Billing.CarrierInvoiceChargeConfigurations.Index',
          meta: {
            label: 'Billing - Carrier Invoice Charge Configurations',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CarrierInvoiceChargeConfigurations.Index" */ '@/views/pages/billing/carrierInvoiceChargeConfigurations/Index'
            );
          }
        },
        {
          path: '/manage/billing/carrierInvoiceChargeConfigurations/edit/:id',
          name: 'Billing.CarrierInvoiceChargeConfigurations.Edit',
          meta: {
            label: 'Billing - Edit Carrier Invoice Charge Configuration',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CarrierInvoiceChargeConfigurations.Form" */ '@/views/pages/billing/carrierInvoiceChargeConfigurations/Form'
            );
          },
          props: true
        },
        {
          path: '/manage/billing/zone-lookup-config',
          name: 'Billing.ZoneLookupCardItems.Index',
          meta: {
            label: 'Billing - Zone Lookup Card Items',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.ZoneLookupCardItems.Index" */ '@/views/pages/billing/zoneLookupCardItems/Index'
            );
          }
        },
        {
          path: '/manage/billing/conversionRateHistoricalRecords',
          name: 'Billing.ConversionRateHistoricalRecords.Index',
          meta: {
            label: 'Billing - Conversion Rate Historical Records',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.ConversionRateHistoricalRecords.Index" */ '@/views/pages/billing/conversionRateHistoricalRecords/Index'
            );
          }
        },

        {
          path: '/manage/billing/ptcFiles',
          name: 'Billing.CustomerBillingLedger.PTCFiles',
          meta: {
            label: 'PTC Files',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerBillingLedger.PTCFiles" */ '@/views/pages/billing/PTCFiles'
            );
          }
        },
        {
          path: '/manage/billing/customerBilingLedger',
          name: 'Billing.CustomerBillingLedger.Index',
          meta: {
            label: 'Billing Ledger',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerBillingLedger.Index" */ '@/views/pages/billing/Index'
            );
          }
        },
        {
          path: '/manage/billing/carrierInvoices',
          name: 'Billing.CarrierInvoices.Index',
          meta: {
            label: 'Carrier Invoices',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CarrierInvoices.Index" */ '@/views/pages/billing/carrierInvoices/Index'
            );
          }
        },
        {
          path: '/manage/billing/carrierInvoices/upload-ups',
          name: 'Billing.CarrierInvoices.UploadUpsFile',
          meta: {
            label: 'Carrier Invoices: Upload UPS Invoice',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CarrierInvoices.UploadUpsFile" */ '@/views/pages/billing/carrierInvoices/UploadUpsFile'
            );
          }
        },
        {
          path: '/manage/billing/carrierInvoices/upload-landmark-mercury',
          name: 'Billing.CarrierInvoices.UploadLandmarkMercuryFile',
          meta: {
            label: 'Carrier Invoices: Upload Landmark - Mercury NL Invoice',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CarrierInvoices.UploadLandmarkMercuryFile" */ '@/views/pages/billing/carrierInvoices/UploadLandmarkMercuryFile'
            );
          }
        },
        {
          path: '/manage/billing/carrierInvoices/upload-dhl',
          name: 'Billing.CarrierInvoices.UploadDhlFile',
          meta: {
            label: 'Carrier Invoices: Upload DHL Invoice',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CarrierInvoices.UploadDhlFile" */ '@/views/pages/billing/carrierInvoices/UploadDhlFile'
            );
          }
        },
        {
          path: '/manage/billing/uploadPtcFile',
          name: 'Billing.CustomerBillingLedger.UploadPtcFile',
          meta: {
            label: 'Upload PTC File',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.CustomerBillingLedger.UploadPtcFile" */ '@/views/pages/billing/UploadPtcFile'
            );
          }
        },
        {
          path: '/manage/billing/rateCards',
          name: 'Billing.RateCards.Index',
          meta: {
            label: 'Rate Cards',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.RateCards.Index" */ '@/views/pages/billing/rateCards/Index'
            );
          }
        },
        {
          path: '/manage/billing/rateCards/manage/:id',
          name: 'Billing.RateCards.View',
          props: true,
          meta: {
            label: 'Edit Rate Card',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.RateCards.Form" */ '@/views/pages/billing/rateCards/Manage'
            );
          }
        },
        {
          path: '/manage/billing/rateCards/create',
          name: 'Billing.RateCards.Create',
          props: true,
          meta: {
            label: 'Create Rate Card',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.RateCards.Form" */ '@/views/pages/billing/rateCards/Form'
            );
          }
        },
        {
          path: '/manage/billing/rateCards/edit/:id',
          name: 'Billing.RateCards.Edit',
          props: true,
          meta: {
            label: 'Manage Rate Card',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Billing.RateCards.Form" */ '@/views/pages/billing/rateCards/Form'
            );
          }
        },

        {
          path: '/manage/clients/create',
          name: 'Admin.Brands.Create',
          props: true,
          meta: {
            label: 'Create Customer',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Brands.Form" */ '@/views/pages/admin/clients/Form'
            );
          }
        },
        {
          path: '/manage/clients/edit/:id',
          name: 'Admin.Brands.Edit',
          props: true,
          meta: {
            label: 'Edit Customer',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Brands.Form" */ '@/views/pages/admin/clients/Form'
            );
          }
        },
        {
          path: '/manage/clients/manage/:id',
          name: 'Admin.Brands.Manage',
          props: true,
          meta: {
            label: 'Manage Customer',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Brands.Manage" */ '@/views/pages/admin/clients/Manage'
            );
          }
        },

        {
          path: '/stores',
          name: 'Stores',
          meta: {
            label: 'Stores',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Manage.Stores" */ '@/views/pages/admin/Stores'
            );
          }
        },

        /* Carriers */
        {
          path: '/admin/carriers',
          name: 'TPL.Carriers.Index',
          meta: {
            label: 'Carriers',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "TPL.Carriers.Index" */ '@/views/pages/integrations/tpl/carriers/Index'
            );
          }
        },
        {
          path: '/admin/carriers/edit/:id',
          name: 'TPL.Carriers.Edit',
          props: true,
          meta: {
            label: 'Edit Carrier',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "TPL.ShipmentServices.Form" */ '@/views/pages/integrations/tpl/shipmentServices/Form'
            );
          }
        },
        {
          path: '/admin/carrier-services',
          name: 'TPL.ShipmentServices.Index',
          meta: {
            label: 'Carrier Services',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "TPL.ShipmentServices.Index" */ '@/views/pages/integrations/tpl/shipmentServices/Index'
            );
          }
        },
        {
          path: '/admin/carrier-services/edit/:id',
          name: 'TPL.ShipmentServices.Edit',
          props: true,
          meta: {
            label: 'Manage Carrier Service',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "PL.ShipmentServices.Form" */ '@/views/pages/integrations/tpl/carriers/Form'
            );
          }
        },
        {
          path: '/admin/users/edit/:id',
          name: 'Admin.Manage.Users.Edit',
          props: true,
          meta: {
            label: 'Update User',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Manage.Users.Form" */ '@/views/pages/admin/Users/Form'
            );
          }
        },
        {
          path: '/admin/users/create',
          name: 'Admin.Manage.Users.Create',
          meta: {
            label: 'Create User',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Manage.Users.Form" */ '@/views/pages/admin/Users/Form'
            );
          }
        },
        {
          path: '/admin/users',
          name: 'Admin.Manage.Users.Index',
          meta: {
            label: 'Manage Users',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Admin.Manage.Users.Index" */ '@/views/pages/admin/Users/Index'
            );
          }
        },
        {
          path: '/other/logs/api',
          name: 'ApiLog',
          meta: {
            label: 'API Log',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Logs.ApiLog" */ '@/views/pages/admin/logActions/ApiLog'
            );
          }
        },
        {
          path: '/other/logs/users',
          name: 'UserLog',
          meta: {
            label: 'Log of User Actions',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Logs.UserLog" */ '@/views/pages/admin/logActions/UserLog'
            );
          }
        },
        {
          path: '/other/logs/system/:projId?',
          name: 'ActionLog',
          props: true,
          meta: {
            label: 'Log of System Actions',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Logs.SystemLog" */ '@/views/pages/admin/logActions/Index'
            );
          }
        },
        {
          path: '/orders/import',
          name: 'Orders.Index.Import',
          props: true,
          meta: {
            label: 'Import Multiple Orders',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Orders.Import" */ '@/views/pages/storefronts/orders/Import'
            );
          }
        },
        {
          path: '/all-orders',
          name: 'Orders.Index.All',
          props: true,
          meta: {
            label: 'Storefront Orders',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Orders.Index" */ '@/views/pages/storefronts/orders/Index'
            );
          }
        },
        {
          path: '/orders/unhold-recs',
          name: 'Orders.Index.UnholdRecs',
          props: { default: true, splitRecs: false, unholdRecs: true },
          meta: {
            label: 'Storefront Orders - Has Inventory',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Orders.Index" */ '@/views/pages/storefronts/orders/Index'
            );
          }
        },
        {
          path: '/orders/split-recs',
          name: 'Orders.Index.SplitRecs',
          props: { default: true, splitRecs: true },
          meta: {
            label: 'Storefront Orders - Recommended Splits',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Orders.Index" */ '@/views/pages/storefronts/orders/Index'
            );
          }
        },
        {
          path: '/orders/create',
          name: 'apps-customer-orders-create',
          props: true,
          meta: {
            label: 'Orders Form',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Orders.Create" */ '@/views/pages/storefronts/orders/Create'
            );
          }
        },
        {
          path: '/orders/details/:id?',
          name: 'Common.OrderDetails',
          props: true,
          meta: {
            label: 'Order Details',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Common.View" */ '@/views/pages/storefronts/orders/View'
            );
          }
        },
        {
          path: '/orders/:projectId?/:orderStatus?/:reqStoreId?',
          name: 'Orders.Index',
          props: true,
          meta: {
            label: 'Storefront Orders',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Orders.Index" */ '@/views/pages/storefronts/orders/Index'
            );
          }
        },
        {
          path: '/fullfillments/:projectId',
          name: 'Common.Fullfillments',
          props: true,
          meta: {
            label: 'Storefront Fullfillments',
            authorized: true
          },
          component: () => {
            return import(
              /* webpackChunkName: "Common.Fullfillments" */ '@/views/pages/common/Fullfillments'
            );
          }
        },
        {
          path: 'reports',
          meta: {
            label: 'Reports'
          },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            // Generated Reports
            {
              name: 'Reports.GeneratedReports.View',
              path: 'generatedReports/view/:id',
              props: true,
              meta: {
                label: 'Generate Report',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.GeneratedReports.View" */ '@/views/pages/reports/generated/View'
                );
              }
            },
            {
              name: 'Reports.GeneratedReports.Create',
              path: 'generatedReports/new/:type?',
              props: true,
              meta: {
                label: 'Generate Report',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.GeneratedReports.Create" */ '@/views/pages/reports/generated/Form'
                );
              }
            },
            // Generated Reports
            {
              name: 'Reports.GeneratedReports.Index',
              path: 'generatedReports/:type?',
              props: true,
              meta: {
                label: 'Generated Reports',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.GeneratedReports.Index" */ '@/views/pages/reports/generated/Index'
                );
              }
            },
            // Ledger Entries for Factoring
            {
              name: 'Reports.LedgerEntries.Index',
              path: 'factoring-ledger',
              props: true,
              meta: {
                label: 'Factoring Ledger',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.LedgerEntries.Index" */ '@/views/pages/reports/ledgerEntries/Index'
                );
              }
            },

            {
              name: 'Reports.WarehouseProductStatistics',
              path: '/report/warehouse-stats/:projId?',
              props: true,
              meta: {
                label: 'Warehouse Product Statistics',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.WarehouseProductStatistics" */ '@/views/pages/reports/WarehouseProductStatistics'
                );
              }
            },
            {
              path: '/report/storefront-stats/:projectId?',
              name: 'Reports.StorefrontProductStatistics',
              props: true,
              meta: {
                label: 'Storefront Product Statistics',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.StorefrontProductStatistics" */ '@/views/pages/reports/StorefrontProductStatistics'
                );
              }
            },
            {
              path: 'products-om-shipped',
              name: 'Reports.ShippedOmProducts',
              meta: {
                label: 'Ordered Items Report - Storefront',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.ShippedProducts" */ '@/views/pages/reports/ShippedOmProducts'
                );
              }
            },
            {
              path: 'products-shipped',
              name: 'Reports.ShippedProducts',
              meta: {
                label: 'Ordered Items Report - WMS',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.ShippedProducts" */ '@/views/pages/reports/ShippedProducts'
                );
              }
            },

            {
              path: 'orders-fulfillment',
              name: 'Reports.FulfillmentReport',
              meta: {
                label: 'Orders Fulfillment Report',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.FulfillmentReport" */ '@/views/pages/reports/FulfillmentReport'
                );
              }
            },
            {
              path: 'shipped',
              name: 'Reports.TotalShipped',
              meta: {
                label: 'Total Shipped',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Reports.TotalShipped" */ '@/views/pages/reports/TotalShipped'
                );
              }
            }
          ]
        },

        {
          path: 'manufacturing',
          meta: {
            label: 'Manufacturing'
          },
          component: {
            render(c) {
              return c('router-view');
            }
          },
          children: [
            {
              path: 'vendors',
              name: 'Admin.Manage.Vendors.Index',
              props: true,
              meta: {
                label: 'Vendors',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Admin.Manage.Vendors.Index" */ '@/views/pages/manufacturing/vendors/Index'
                );
              }
            },
            {
              path: 'vendors/create',
              name: 'Admin.Manage.Vendors.Create',
              props: true,
              meta: {
                label: 'Create Vendor',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Admin.Manage.Vendors.Form" */ '@/views/pages/manufacturing/vendors/Form'
                );
              }
            },
            {
              path: 'vendors/edit/:id',
              name: 'Admin.Manage.Vendors.Edit',
              props: true,
              meta: {
                label: 'Edit Vendor',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Admin.Manage.Vendors.Form" */ '@/views/pages/manufacturing/vendors/Form'
                );
              }
            },
            // ----------- Manufacturing
            // work-orders
            {
              path: 'work-orders',
              name: 'Manufacturing.WorkOrders.Index',
              meta: {
                label: 'Work Orders',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.WorkOrders.Index" */ '@/views/pages/manufacturing/workOrders/Index.vue'
                );
              }
            },
            {
              path: 'work-orders/create',
              name: 'Manufacturing.WorkOrders.Create',
              meta: {
                label: 'Create Work Order',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.WorkOrders.Form" */ '@/views/pages/manufacturing/workOrders/Form.vue'
                );
              }
            },
            {
              path: 'work-orders/edit/:id',
              name: 'Manufacturing.WorkOrders.Edit',
              props: true,
              meta: {
                label: 'Edit Work Order',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.WorkOrders.Form" */ '@/views/pages/manufacturing/workOrders/Form.vue'
                );
              }
            },
            // Processes

            // RnDProjects
            {
              path: 'RnD/projects',
              name: 'Manufacturing.RnDProjects.Index',
              meta: {
                label: 'R&D Projects',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.RnDProjects.Index" */ '@/views/pages/manufacturing/rndProjects/Index.vue'
                );
              }
            },
            // RnDProjects
            // Components/Products
            {
              path: 'RnD/projects/create',
              name: 'Manufacturing.RnDProjects.Create',
              meta: {
                label: 'Create a R&D Project',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.RnDProjects.Form" */ '@/views/pages/manufacturing/rndProjects/Form.vue'
                );
              }
            },
            {
              path: 'RnD/projects/edit/:id',
              name: 'Manufacturing.RnDProjects.Edit',
              props: true,
              meta: {
                label: 'Edit R&D Project',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.RnDProjects.Form" */ '@/views/pages/manufacturing/rndProjects/Form.vue'
                );
              }
            },

            // BillOfMaterials
            {
              path: 'billOfMaterials',
              name: 'Manufacturing.BillOfMaterials.Index',
              meta: {
                label: 'Bill of Materials',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.BillOfMaterials.Index" */ '@/views/pages/manufacturing/billOfMaterials/Index.vue'
                );
              }
            },
            // BillOfMaterials
            // Components/Products
            {
              path: 'billOfMaterials/create',
              name: 'Manufacturing.BillOfMaterials.Create',
              meta: {
                label: 'Create Bill of Materials',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.BillOfMaterials.Form" */ '@/views/pages/manufacturing/billOfMaterials/Form.vue'
                );
              }
            },
            {
              path: 'billOfMaterials/edit/:id',
              name: 'Manufacturing.BillOfMaterials.Edit',
              props: true,
              meta: {
                label: 'Edit Material',
                authorized: true
              },
              component: () => {
                return import(
                  /* webpackChunkName: "Manufacturing.BillOfMaterials.Form" */ '@/views/pages/manufacturing/billOfMaterials/Form.vue'
                );
              }
            }
          ]
        }
      ]
    },

    {
      path: '*',
      name: 'Error 404',
      component: Page404
    }
  ];
}
let router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes()
});

/* auth middleguard */
router.beforeEach((to, from, next) => {
  if (to.meta.authorized) {
    let storageRefToken = localStorage.getItem('refreshToken');
    if(!store.getters['account/getRefreshToken'] && storageRefToken) {
      store.commit('account/setRefreshToken', {
        refreshToken: storageRefToken,
        jwtToken: ''
      });
    } else {
      storageRefToken = store.getters['account/getRefreshToken'];
    }
    if (store.getters['account/isLoggedIn']) {
      next();
    } else {
      if (storageRefToken) {
        store
          .dispatch(
            'account/refreshToken',
            storageRefToken
          )
          .then(response => {
            store.dispatch('account/autoRefreshToken');
            next();
          })
          .catch(err => {
            console.error(err);
            localStorage.removeItem('refreshToken');
            //router.push('/');
            window.location.replace(
              '/login?_r=' +
                Math.random()
                  .toString(36)
                  .substring(2, 5) +
                '&redirToUrl=' +
                (location.pathname + location.search).substring(1)
            );
          });
      } else {
        //router.push('/');
        window.location.replace(
          '/login?_r=' +
            Math.random()
              .toString(36)
              .substring(2, 5) +
            '&redirToUrl=' +
            (location.pathname + location.search).substring(1)
        );
      }
    }
  } else {
    next();
  }
});

export default router;
